import React from 'react';
import PropTypes from 'prop-types';
import CheckoutButton from '../checkout-button';
import LoginButton from './login-button';

const CheckoutButtons = ({
  quantity,
  checkoutBlocker,
  crossSellItemCheckOutClick,
  handleCheckoutClick,
  checkoutDisabled,
  checkout,
  loggedIn,
}) => {
  const checkoutLoginBtnEnabled =
    !loggedIn &&
    checkout?.withoutLogin &&
    checkout?.allowAccountSignupInCheckout;

  if (quantity) {
    return (
      <>
        {checkoutLoginBtnEnabled && <LoginButton />}
        <CheckoutButton
          checkout={checkout}
          loggedIn={loggedIn}
          text={checkoutLoginBtnEnabled ? 'Check Out As Guest' : undefined}
          checkoutDisabled={checkoutDisabled}
          onClick={handleCheckoutClick}
          crossSellItemCheckOutClick={() => crossSellItemCheckOutClick()}
          checkoutBlocker={checkoutBlocker}
        />
      </>
    );
  }
  return null;
};

CheckoutButtons.propTypes = {
  checkoutBlocker: PropTypes.number,
  crossSellItemCheckOutClick: PropTypes.func,
  quantity: PropTypes.number,
  handleCheckoutClick: PropTypes.func,
  checkoutDisabled: PropTypes.bool,
  loggedIn: PropTypes.bool,
  checkout: PropTypes.shape({
    withoutLogin: PropTypes.bool,
    allowAccountSignupInCheckout: PropTypes.bool,
  }),
};

CheckoutButtons.defaultProps = {
  checkoutBlocker: null,
  crossSellItemCheckOutClick: null,
  quantity: null,
  handleCheckoutClick: null,
  checkoutDisabled: true,
};

export default CheckoutButtons;
